import 'css-chunk:src/feature/flip-and-tip/FlipAndTipStartPage.module.scss';export default {
  "main": "FlipAndTipStartPage_main"
};